// ssww-krushisetu\frontend\src\ColorFont\themes.js

const FIGMA_PALETTE = {
  brandGreen: "#16A249",          // link, primary, icon_bg_selected, nav_sell_text
  brandGreenDark: "#149343",      // primary_dark and both sides of the button gradient
  textBody: "#6D786D",            // text and nav_text
  textHeading: "#171C17",         // text_dark, dark, and search_text
  appBackground: "#FFFFFF",       // background_light (and background_header)
  borderSoft: "#F4F6F8",          // Light grey for subtle separation
  borderStrong: "#DFE3E8",        // dashboard_card_border, carbon_border_dashed, and carbon_border_solid
  carbonBlue: "#00B4D8",          // nav_text_active, nav_carbon, carbon_bg_main, carbon_border_selected
  pureWhite: "#FFFFFF",           // light, white_bg, carbon_bg_card
};

export const themes = {
  // 'classic' is the primary theme mapping the Figma design tokens
  classic: {
    background_light: FIGMA_PALETTE.pureWhite,
    background2: FIGMA_PALETTE.pureWhite,
    background3: "rgba(22, 162, 73, 0.024)",
    text: FIGMA_PALETTE.textBody,
    text_dark: FIGMA_PALETTE.textHeading,
    link: FIGMA_PALETTE.brandGreen,
    border: FIGMA_PALETTE.borderSoft,
    primary: FIGMA_PALETTE.brandGreen,
    primary_dark: FIGMA_PALETTE.brandGreenDark,
    primary_continue: "#149041",
    google_bg: "rgba(22, 162, 73, 0.024)",
    google_shadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    primary_light: "rgba(22, 162, 73, 0.3)",
    button: `linear-gradient(to right, ${FIGMA_PALETTE.brandGreenDark}, ${FIGMA_PALETTE.brandGreenDark})`,
    // UNIVERSAL SHADOW TOKENS
    shadow_card: "0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 30px -6px rgba(0, 0, 0, 0.12)",
    shadow_button_primary: "0px 2.92px 11.67px -1.83px rgba(0, 0, 0, 0.06), 0px 5.25px 19.92px -4.17px rgba(9, 68, 31, 0.11)",
    shadow_continue: "0px 5.9225px 22.3825px -4.615px rgba(7, 50, 23, 0.114), 0px 2.6925px 10.77px -1.385px rgba(0, 0, 0, 0.05)",
    // ROLE SELECTION SPECIFIC
    card_border_pale: "rgba(174, 214, 188, 0.796)",
    tag_bg: "#F4F6F4",
    role_selected_bg: "rgba(22, 162, 73, 0.05)",
    icon_bg_selected: FIGMA_PALETTE.brandGreen,
    icon_bg_unselected: "#F4F6F4",
    light: FIGMA_PALETTE.pureWhite,
    dark: FIGMA_PALETTE.textHeading,
    red: "#ff0000",
    sold: "gray",
    // WELCOME SUCCESS SCREEN SPECIFIC
    success_overlay_bg: "rgba(34, 195, 93, 0.1)",
    info_box_bg: "rgba(22, 162, 73, 0.05)",
    info_box_border: "rgba(22, 162, 73, 0.2)",
    // HEADER UNIVERSAL FIGMA TOKENS
    background_header: FIGMA_PALETTE.pureWhite,
    backdrop_blur: "blur(8px)",
    nav_text: FIGMA_PALETTE.textBody,
    nav_text_active: FIGMA_PALETTE.carbonBlue,
    nav_carbon: FIGMA_PALETTE.carbonBlue,
    nav_sell_bg: "rgba(22, 162, 73, 0.08)",
    nav_sell_text: FIGMA_PALETTE.brandGreen,
    search_bg: "#FFFFFF",
    search_text: FIGMA_PALETTE.textHeading,
    // FARMER DASHBOARD SPECIFIC
    boost_bg: "linear-gradient(90deg, #F59E0B 0%, #F97316 100%)",
    gray_empty_text: "#A6A6A6",
    action_box_shadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.1)",
    white_bg: FIGMA_PALETTE.pureWhite,
    dashboard_card_border: FIGMA_PALETTE.borderStrong,
    // ADD CROP (ADD PHOTOS) SCREEN SPECIFIC
    step_bg: "rgba(22, 162, 73, 0.2)",
    dashed_border: FIGMA_PALETTE.borderSoft,
    btn_shadow_upload: "0px 4px 16px -4px rgba(0, 0, 0, 0.08), 0px 2px 8px -2px rgba(22, 162, 74, 0.1)",
    // CARBON CREDITS DASHBOARD SPECIFIC
    carbon_bg_main: FIGMA_PALETTE.carbonBlue,
    carbon_bg_light: "#B2EBF2",
    carbon_bg_card: FIGMA_PALETTE.pureWhite,
    carbon_text_main: "#0F1729",
    carbon_text_secondary: "#65758B",
    carbon_shadow_card: "0px 8px 30px 0px rgba(0, 0, 0, 0.04)",
    carbon_shadow_btn: "0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1)",
    carbon_shadow_btn_outline: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    carbon_gradient_earning: "linear-gradient(135deg, #1A4D2E 0%, #10451D 100%)",
    carbon_shadow_earning: "0px 12px 40px 0px rgba(0, 0, 0, 0.08)",
    carbon_text_earning_bg: "#C8E6C9",
    carbon_text_active_bg: "#A5D6A7",
    carbon_overlay: "rgba(255, 255, 255, 0.05)",
    carbon_border_dashed: FIGMA_PALETTE.borderStrong,
    carbon_step_bg_unselected: "#E2E8F0",
    carbon_step_text_unselected: "#64748B",
    carbon_border_solid: FIGMA_PALETTE.borderStrong,
    carbon_bg_selected: "#E0F7FA",
    carbon_border_selected: FIGMA_PALETTE.carbonBlue,
    carbon_text_credits: "#0097A7",
    carbon_bg_estimated: "#E0F7FA",
    carbon_border_estimated: "#80DEEA",
    carbon_text_estimated_title: "#00838F",
    carbon_bg_pill: "#B2EBF2",
    carbon_text_pill: "#0097A7",
    carbon_bg_estimated_solid: "#00A9CC",
    carbon_warning_bg: "#FFFDE7",
    carbon_warning_border: "#FFF59D",
    carbon_warning_text: "#D84315",
    // UPLOAD PROOF SCREEN SPECIFIC
    carbon_upload_proof_bg: "#FFFFFF",
    carbon_upload_input_bg: "#FFFFFF",
    carbon_upload_input_bg_alt: "#F8FAFC",
    carbon_upload_tips_bg: "#FFFBEB",
    carbon_upload_tips_border: "#FDE68A",
    carbon_upload_tips_text: "#92400E",
    carbon_upload_tips_bullet: "#B45309",
    // MY WALLET SCREEN SPECIFIC
    carbon_wallet_btn_bg: "#FCFEFC",
    carbon_wallet_btn_text: "#10451D",
    carbon_wallet_tab_bg: "#FFFFFF",
    carbon_wallet_tab_container: "#F3F5F7",
    // NEW HEADER/SIDEBAR LAYOUT
    layout_bg: "#FFFFFF",
    layout_border: "#919EAB14",
    layout_text_primary: "#1C252E",
    layout_add_btn: "#B71D18",
    layout_gradient_avatar: "linear-gradient(135deg, #B7E4C7 0%, #149343 100%)",
    // ADD CROP SCREEN SPECIFIC
    add_crop_stepper_active: "#16A249",
    add_crop_stepper_inactive: "#DFE3E8",
    add_crop_stepper_text: "#FFFFFF",
    add_crop_stepper_text_inactive: "#637381",
    add_crop_card_bg: "#FFFFFF",
    add_crop_card_border: "rgba(145, 158, 171, 0.2)",
    add_crop_option_border: "rgba(145, 158, 171, 0.32)",
    add_crop_option_active_border: "#16A249",
    add_crop_option_active_bg: "rgba(22, 162, 73, 0.08)",
    // V1 ADD PLOTS STEP 1 SPECIFIC
    v1_crop_search_bg: "#FFFFFF",
    v1_crop_search_border: "#E0E5EB",
    v1_crop_pill_bg: "#FFFFFF",
    v1_crop_pill_border: "#BCE0BC",
    v1_crop_pill_icon: "#16A249",
    v1_crop_pill_text: "#1C252E",
    v1_crop_tab_active: "#16A249",
    v1_crop_tab_inactive: "#637381",
    v1_crop_custom_bg: "#F4F6F4",
    v1_crop_custom_border: "#B2E0B2",
    v1_crop_custom_icon_bg: "#D1F0D1",
    v1_crop_selected_bg: "#D1F0D1",
    v1_crop_selected_text: "#10451D",
    // UNIVERSAL LAYOUT TOKENS (MATCHING CARBON CREDITS STANDARD)
    layout_padding_x: "32px",
    layout_padding_x_mobile: "16px",
    layout_padding_y: "24px",
    layout_max_width: "1600px",
    layout_margin_center: "0 auto",
  },

  default: {
    background_light: "#FFFFFF",
    background2: "#FFFFFF",
    background3: "#e6cecb",
    text: "#6D786D",
    text_dark: "#171C17",
    link: "#462521",
    border: "#E0E5EB",
    primary: "#462521",
    primary_dark: "#341c1a",
    primary_light: "#c68d86",
    button: "linear-gradient(to right, #462521, #462521)",
    light: "#ffffff",
    dark: "#171C17",
    red: "#ff0000",
    sold: "gray",
    // UNIVERSAL LAYOUT TOKENS
    layout_padding_x: "24px",
    layout_padding_x_mobile: "16px",
  },

  modern: {
    background_light: "#FFFFFF",
    background2: "#FFFFFF",
    background3: "#fafafa",
    text: "#868889",
    link: "#ADD8E6",
    border: "#6495ED",
    primary: "#588ebb",
    primary_dark: "#4682B4",
    primary_light: "#6a9bc3",
    button: "linear-gradient(to right,#6495ED, #6495ED)",
    light: "#ffffff",
    dark: "#000000",
    red: "#DC143C",
    sold: "#808080",
    sidebar_primary: "",
    sidebar_primary_dark: "",
    sidebar_primary_light: "",
  },

  tangerine: {
    background_light: "#FFFFFF",
    background2: "#FFFFFF",
    background3: "#fafafa",
    text: "#868889",
    link: "#FFD700",
    border: "#FFA07A",
    primary: "#ff9719",
    primary_dark: "#FF8C00",
    primary_light: "#ffa332",
    button: "linear-gradient(to right,#FF8C00, #FF8C00)",
    light: "#ffffff",
    dark: "#000000",
    red: "#FF0000",
    sold: "#808080",
    sidebar_primary: "",
    sidebar_primary_dark: "",
    sidebar_primary_light: "",
  },

  bubblegum: {
    background_light: "#FFFFFF",
    background2: "#FFFFFF",
    background3: "#fafafa",
    text: "#868889",
    link: "#ADD8E6",
    border: "#b27883",
    primary: "#915461",
    primary_dark: "#714243",
    primary_light: "#ab6e74",
    button: "linear-gradient(to right,#814b56, #814b56)",
    light: "#ffffff",
    dark: "#000000",
    red: "#DC143C",
    sold: "#808080",
    sidebar_primary: "",
    sidebar_primary_dark: "",
    sidebar_primary_light: "",
  },

  woodland: {
    background_light: "#FFFFFF",
    background2: "#FFFFFF",
    background3: "#fafafa",
    text: "#868889",
    link: "#ADD8E6",
    border: "#a39c46",
    primary: "#938e1f",
    primary_dark: "#696616",
    primary_light: "#beb728",
    button: "linear-gradient(to right,#726e18, #726e18)",
    light: "#ffffff",
    dark: "#000000",
    red: "#DC143C",
    sold: "#808080",
    sidebar_primary: "",
    sidebar_primary_dark: "",
    sidebar_primary_light: "",
  }
};